import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import usePendingDeployment from './usePendingDeployment';
import useScheduledDeployment from './useScheduledDeployment';
import useDeploymentHistory from './useDeploymentHistory';
import usePaginatedDeploymentHistory from './usePaginatedDeploymentHistory';
import Deploy from './Deploy';

const HISTORY_STEP = 10;

const DeployContainer = (props) => {
  const {
    pendingDeployment,
    refetchPendingDeployment
  } = usePendingDeployment();
  const { scheduledDeployment, isFetching: scheduledLoading } = useScheduledDeployment();
  const {
    activeDeployment,
    deploymentHistory,
    isFetching: historyLoading,
    refetchDeploymentHistory
  } = useDeploymentHistory({ onlyVersions: true });
  // The most recent deployments, ten more each time older ones are asked for.
  const [historyLimit, setHistoryLimit] = useState(HISTORY_STEP);
  const {
    deploymentHistory: recentHistory,
    isFetching: recentHistoryLoading,
    refetchPaginatedDeploymentHistory
  } = usePaginatedDeploymentHistory({ limit: historyLimit });
  const total = deploymentHistory ? deploymentHistory.length : 0;
  // Only super admins redeploy the whole site; AIXC deployers are kept to AIXC pages (the server refuses it too).
  const canRedeployAll = useSelector(state => !!(state.app.user && state.app.user.isSuperAdmin && state.app.user.isActive));

  return <Deploy
    {...props}
    {...{
      pendingDeployment,
      refetchPendingDeployment,
      refetchPaginatedDeploymentHistory,
      scheduledDeployment,
      activeDeployment,
      deploymentHistory,
      // The next version is worked out from these two (the scheduled list can take a while: the server checks
      // the schedule service).
      versionLoading: scheduledLoading || historyLoading,
      refetchDeploymentHistory,
      recentHistory,
      recentHistoryLoading,
      canShowOlder: total > historyLimit,
      canRedeployAll,
      onShowOlder: () => setHistoryLimit(n => n + HISTORY_STEP * 2)
    }}
  />
};

export default DeployContainer;
